import chroma from "chroma-js";

interface ThemeColors {
    info?: ThemeColorInfo;
    success?: ThemeColorInfo;
    warning?: ThemeColorInfo;
    error?: ThemeColorInfo;
    disabled?: ThemeColorInfo;
    "disabled-light"?: ThemeColorInfo;
}

interface ThemeColorInfo {
    className: string;
    color: string;
}

const eventlistenerAdded = false;
let themeBaseColors: ThemeColors = {};
export const themeColorNames = ["info", "success", "warning", "error", "disabled", "disabled-light"];

const getThemeColors = (): ThemeColors => {
    const themeObject = {};
    themeColorNames.forEach((name) => (themeObject[name] = { className: `ux-color-${name}` }));
    if (Object.keys(themeBaseColors).length > 0) {
        return themeBaseColors;
    }

    const div = document.createElement("div");
    div.style.display = "none";
    div.innerHTML = themeColorNames.map((name) => `<i class="${themeObject[name].className}"></i>`).join("");
    document.body.append(div);

    themeColorNames.forEach((name) => {
        const element: HTMLElement = div.querySelector(`.${themeObject[name].className}`);
        if (element === null) {
            return;
        }
        themeObject[name].color = getComputedStyle(element)?.color;
    });
    div.remove();
    themeBaseColors = themeObject;
    if (!eventlistenerAdded) {
        document.addEventListener("uxThemeChange", () => window.setTimeout(() => (themeBaseColors = {})));
    }

    return themeBaseColors;
};

export const getThemeColor = (color: string) => {
    const themeColors = getThemeColors();
    if (themeColors[color]) {
        return themeColors[color].color;
    }
    return color;
};

export const generateColors = (number: number, input: string[] = themeColorNames): string[] => {
    const baseColors = getThemeColors();
    const colors = [];
    input.forEach((col) => {
        if (themeColorNames.includes(col)) {
            if (baseColors[col]) {
                colors.push(baseColors[col].color);
            }
            return;
        }
        if (chroma.valid(col)) {
            colors.push(col);
        }
    });

    if (colors.length >= number) {
        return colors.slice(0, number);
    }
    if (colors.length < 2) {
        colors.push("#4B4B4B", "#C5C5C5");
    }
    return chroma.scale(colors).colors(number);
};
